<table class="ir-plugin-table" style="margin-bottom: 10px" *ngFor="let yesNo of questions">
  <tr *ngIf="yesNo.Label">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ yesNo.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1 ir-installationreceived_comment"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="yesNo.Status && yesNo.Status >= 0">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationyesno.status' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">
          {{ yesNo.Status | yesnostatus }}
        </span>
      </p>
    </td>
  </tr>
</table>
